module.exports = __webpack_public_path__ + "img/Boy_020004.8ce2a289.png";